// extracted by mini-css-extract-plugin
export default {"content":"styles_content__N+zJP","text":"styles_text__HEd45"};